import { css } from 'styled-components';

export const styleGaramond = css`
  font-family: ${({ theme }) => theme.font.family.garamond};
  letter-spacing: ${({ theme }) => theme.letterSpacing.garamond};
`;
